const Colors = {
  header: '#2f353f',
  panelBorderColor: '#31353c'
};

export { Colors };


// WEBPACK FOOTER //
// ./src/utils/Colors.js